import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { EInvoicePaymentMeansCode } from '../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../shared/components/genericBaseModelDropDown';
import { EInvoicePaymentMeansCodeService } from '../../services/e-invoice-payment-means-code.service';


@Component({
  selector: 'app-e-invoice-payment-means-code-dropdown',
  templateUrl: './e-invoice-payment-means-code-dropdown.component.html',
  providers: [
    EInvoicePaymentMeansCodeService
  ],
  standalone: true,
  imports: [
    CommonModule,
    TooltipModule,
  ]
})
export class EInvoicePaymentMeansCodeDropdownComponent extends GenericBaseModelDropDown<EInvoicePaymentMeansCode> {

  constructor(private service: EInvoicePaymentMeansCodeService) {
    super(service, "EInvoicePaymentMeansCode");
    this.autoSelectSingleResult.set(true); //if wanted
  }

}
